import React from "react"
import { withTheme } from "emotion-theming"
import { ResponsiveBar } from "@nivo/bar"
import Responsive from "react-responsive"

import { foodCollected } from "@data/food-collected"

import { Label, Tooltip, Wrapper } from "./styles"

const FoodCollected = ({ theme, colour }) => (
  <Wrapper>
    <ResponsiveBar
      data={foodCollected}
      indexBy="label"
      keys={["2016", "2017", "2018"]}
      margin={{ top: 40, bottom: 20, left: 225 }}
      padding={0.5}
      layout="horizontal"
      groupMode="grouped"
      enableGridX={true}
      colors={[
        theme.colours.lightPrimary,
        theme.colours.secondary,
        theme.colours.success,
      ]}
      axisTop={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        renderTick: tick => (
          <Responsive minWidth={992}>
            <g key={tick.key} transform={`translate(${tick.x},${tick.y})`}>
              <line
                x1="0"
                x2="0"
                y1="0"
                y2={tick.lineY}
                style={{ stroke: colour || theme.color }}
              />
              <text
                textAnchor="end"
                dominantBaseline="middle"
                transform={`translate(${-tick.textY - tick.lineY},${tick.textY +
                  tick.lineY})`}
                style={{
                  fill: colour || theme.color,
                  fontSize: 14,
                  fontWeight: 700,
                }}
              >
                {tick.value}%
              </text>
            </g>
          </Responsive>
        ),
      }}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        renderTick: tick => (
          <g key={tick.key} transform={`translate(${tick.x - 10},${tick.y})`}>
            <text
              textAnchor="end"
              dominantBaseline="middle"
              transform={`translate(${tick.textX},${tick.textY})`}
              style={{
                fill: colour || theme.color,
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              {tick.value}
            </text>
          </g>
        ),
      }}
      enableGridY={false}
      enableLabel={false}
      labelFormat={d => (
        <Label x={50} textAnchor="start">
          {d}
        </Label>
      )}
      animate={false}
      tooltip={props => <Tooltip>{props.value}%</Tooltip>}
      legends={[
        {
          dataFrom: "keys",
          anchor: "right",
          direction: "column",
          justify: false,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 1,
          symbolSize: 20,
        },
      ]}
    />
  </Wrapper>
)

export default withTheme(FoodCollected)
